import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Chart, ChartOptions, registerables } from 'chart.js';
import { DashboardService } from '../shared/services/dashboard/dashboard.service';
import { ErrorHandleService } from '../shared/services/error-handle/error-handle.service';
import { AuthService } from '../shared/services/auth/auth.service';
Chart.register(...registerables);

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  title = 'RedeDeObras-Angular';

  companyId: any;
  restrictionKey: any;
  menuModules: Array<any> = [];
  moduleID: number;

  obrasModulosChart: any;
  faseDaObraChart: any;
  tipoDeObraChart: any;
  padraoDeObraChart: any;
  listaUFChart: any;
  obraPorResponsaveisChart: any;
  statusNegociacoesChart: any;


  private readonly paletaCores: string[] = [
    '#e4a757', // blue
    '#bee2b1', // info
    '#e2b68c', // primary
    '#b7cc95', // yellow
    '#b85500', // warning
    '#93b9e4', // update
    '#586572', // secondary
  ];

  private readonly textColor = '#586572';
  private readonly gridColor = '#dfe3e7';

  optionsChart: ChartOptions<'bar'> = {
    indexAxis: 'y',
    scales: {
      x: {
        border: {
          color: this.gridColor,
        },
        grid: {
          display: false,
        },
        ticks: {
          color: this.textColor,
        },
      },
      y: {
        border: {
          color: this.gridColor,
        },
        grid: {
          display: false,
        },
        ticks: {
          color: this.textColor,
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
    },
  };

  constructor(
    private _dashboardService: DashboardService,
    private _errorHandleService: ErrorHandleService,
    private readonly authService: AuthService
  ) {
    this.companyId = this.authService.companyID;
    this.restrictionKey = this.authService.restrictionKey;
  }

  ngOnInit(): void {
    this.modulosFornecedor();
  }

  private gerarCores(quantidade: number): string[] {
    return Array.from(
      { length: quantidade },
      (_, i) => this.paletaCores[i % this.paletaCores.length]
    );
  }

  async modulosFornecedor() {
    await this._dashboardService
      .modulosFornecedor(this.companyId, this.restrictionKey)
      .subscribe(
        (response) => {
          if (response.success) {
            this.menuModules = response.data;
            this.getModuleID(this.menuModules[0].moduleID);
          } else {
            this._errorHandleService.throwConsoleError(response);
          }
        },
        (error) => {
          this._errorHandleService.redirectToNotFound(error);
        }
      );
  }

  getModuleID(data) {
    this.moduleID = data;
    this.obrasModulos(this.moduleID);
    this.faseObra(this.moduleID);
    this.tipoObra(this.moduleID);
    this.listaUF(this.moduleID);
    this.obraPorResponsaveis(this.moduleID);
    this.statusNegociacoes(this.moduleID);

    // O gráfico de Padrão da obra só existe no módulo Imobiliário (id 234)
    if (this.moduleID === 234) {
      this.padraoObra(this.moduleID);
    }
  }

  obrasModulos(data) {
    this._dashboardService
      .qtdeObrasModulo(this.companyId, this.restrictionKey, data)
      .subscribe(
        (response) => {
          if (response.success) {
            let objCompleto = response.data.quantityXModules;
            let objValues = Object.values(objCompleto);
            let objKeys = Object.keys(objCompleto);

            if (this.obrasModulosChart) {
              this.obrasModulosChart.clear();
              this.obrasModulosChart.destroy();
            }

            this.obrasModulosChart = new Chart('grafico-ObrasModulo', {
              type: 'bar',
              data: {
                labels: objKeys,
                datasets: [
                  {
                    label: '',
                    data: objValues,
                    borderWidth: 1,
                    backgroundColor: this.gerarCores(objValues.length),
                    maxBarThickness: 36,
                  },
                ],
              },
              options: this.optionsChart,
            });
          } else {
            this._errorHandleService.throwConsoleError(response);
          }
        },
        (error) => {
          this._errorHandleService.redirectToNotFound(error);
        }
      );
  }

  async faseObra(data) {
    await this._dashboardService
      .faseDaObra(this.companyId, this.restrictionKey, data)
      .subscribe(
        (response) => {
          if (response.success) {
            let objCompleto = response.data.phaseXWork;
            let objValues = Object.values(objCompleto);
            let objKeys = Object.keys(objCompleto);

            if (this.faseDaObraChart !== undefined) {
              this.faseDaObraChart.clear();
              this.faseDaObraChart.destroy();
            }
            this.faseDaObraChart = new Chart('grafico-FaseDaObra', {
              type: 'bar',
              data: {
                labels: objKeys,
                datasets: [
                  {
                    label: '',
                    data: objValues,
                    borderWidth: 1,
                    backgroundColor: this.gerarCores(objValues.length),
                    maxBarThickness: 36,
                  },
                ],
              },
              options: this.optionsChart,
            });
          } else {
            this._errorHandleService.throwConsoleError(response);
          }
        },
        (error) => {
          this._errorHandleService.redirectToNotFound(error);
        }
      );
  }

  async tipoObra(data) {
    await this._dashboardService
      .tipoDeObra(this.companyId, this.restrictionKey, data)
      .subscribe(
        (response) => {
          if (response.success) {
            let objCompleto = response.data.typeOfWorkXWork;
            let objValues = Object.values(objCompleto);
            let objKeys = Object.keys(objCompleto);

            if (this.tipoDeObraChart !== undefined) {
              this.tipoDeObraChart.clear();
              this.tipoDeObraChart.destroy();
            }
            this.tipoDeObraChart = new Chart('grafico-TipoDeObra', {
              type: 'bar',
              data: {
                labels: objKeys,
                datasets: [
                  {
                    label: '',
                    data: objValues,
                    borderWidth: 1,
                    backgroundColor: this.gerarCores(objValues.length),
                    maxBarThickness: 36,
                  },
                ],
              },
              options: this.optionsChart,
            });
          } else {
            this._errorHandleService.throwConsoleError(response);
          }
        },
        (error) => {
          this._errorHandleService.redirectToNotFound(error);
        }
      );
  }

  async padraoObra(data) {
    await this._dashboardService
      .padraoDeObra(this.companyId, this.restrictionKey, data)
      .subscribe(
        (response) => {
          if (response.success) {
            let objCompleto = response.data.patternWorkXWork;
            let objValues = Object.values(objCompleto);
            let objKeys = Object.keys(objCompleto);

            if (this.padraoDeObraChart !== undefined) {
              this.padraoDeObraChart.clear();
              this.padraoDeObraChart.destroy();
            }
            this.padraoDeObraChart = new Chart('grafico-PadraoDaObra', {
              type: 'bar',
              data: {
                labels: objKeys,
                datasets: [
                  {
                    label: '',
                    data: objValues,
                    borderWidth: 1,
                    backgroundColor: this.gerarCores(objValues.length),
                    maxBarThickness: 36,
                  },
                ],
              },
              options: this.optionsChart,
            });
          } else {
            this._errorHandleService.throwConsoleError(response);
          }
        },
        (error) => {
          this._errorHandleService.redirectToNotFound(error);
        }
      );
  }

  async listaUF(data) {
    await this._dashboardService
      .listaUF(this.companyId, this.restrictionKey, data)
      .subscribe(
        (response) => {
          if (response.success) {
            let objCompleto = response.data.workStateXWork;
            let objValues = Object.values(objCompleto);
            let objKeys = Object.keys(objCompleto);

            if (this.listaUFChart !== undefined) {
              this.listaUFChart.clear();
              this.listaUFChart.destroy();
            }

            this.listaUFChart = new Chart('grafico-UF', {
              type: 'bar',
              data: {
                labels: objKeys,
                datasets: [
                  {
                    label: '',
                    data: objValues,
                    borderWidth: 1,
                    backgroundColor: this.gerarCores(objValues.length),
                    maxBarThickness: 36,
                    barPercentage: 0.7,
                  },
                ],
              },
              options: {
                indexAxis: 'y',
                scales: {
                  x: {
                    border: {
                      color: this.gridColor,
                    },
                    grid: {
                      display: false,
                    },
                    ticks: {
                      color: this.textColor,
                    },
                  },
                  y: {
                    border: {
                      color: this.gridColor,
                    },
                    grid: {
                      display: false,
                    },
                    ticks: {
                      color: this.textColor,
                    },
                  },
                },
                plugins: {
                  legend: {
                    display: false,
                  },
                },
              },
            });
          } else {
            this._errorHandleService.throwConsoleError(response);
          }
        },
        (error) => {
          this._errorHandleService.redirectToNotFound(error);
        }
      );
  }

  async obraPorResponsaveis(data) {
    await this._dashboardService
      .obraPorResponsaveis(this.companyId, this.restrictionKey, data)
      .subscribe(
        (response) => {
          if (response.success) {
            let objCompleto = response.data.responsibleWorkXWork;
            let objValues = Object.values(objCompleto);
            let objKeys = Object.keys(objCompleto);

            if (this.obraPorResponsaveisChart !== undefined) {
              this.obraPorResponsaveisChart.clear();
              this.obraPorResponsaveisChart.destroy();
            }
            this.obraPorResponsaveisChart = new Chart(
              'grafico-ObrasPorResponsaveis',
              {
                type: 'bar',
                data: {
                  labels: objKeys,
                  datasets: [
                    {
                      label: '',
                      data: objValues,
                      borderWidth: 1,
                      backgroundColor: this.gerarCores(objValues.length),
                    maxBarThickness: 36,
                    },
                  ],
                },
                options: this.optionsChart,
              }
            );
          } else {
            this._errorHandleService.throwConsoleError(response);
          }
        },
        (error) => {
          this._errorHandleService.redirectToNotFound(error);
        }
      );
  }

  async statusNegociacoes(data) {
    await this._dashboardService
      .statusNegociacoes(this.companyId, this.restrictionKey, data)
      .subscribe(
        (response) => {
          if (response.success) {
            let objCompleto = response.data.negotiationStatusWorkXWork;
            let objValues = Object.values(objCompleto);
            let objKeys = Object.keys(objCompleto);
            let colors = [
              '#586572',
              'rgb(219, 175, 135)',
              '#bad2e9',
              '#bfddb4',
              '#d0db8d',
            ];
            if (this.statusNegociacoesChart !== undefined) {
              this.statusNegociacoesChart.clear();
              this.statusNegociacoesChart.destroy();
            }
            this.statusNegociacoesChart = new Chart(
              'grafico-StatusNegociacoes',
              {
                type: 'doughnut',
                data: {
                  labels: objKeys,
                  datasets: [
                    {
                      label: '',
                      data: objValues,
                      borderWidth: 0.5,
                      backgroundColor: colors,
                    },
                  ],
                },
                options: {
                  indexAxis: 'y',
                  plugins: {
                    legend: {
                      display: true,
                      labels: {
                        color: this.textColor,
                      },
                      position: 'bottom',
                    },
                  },
                },
              }
            );
          } else {
            this._errorHandleService.throwConsoleError(response);
          }
        },
        (error) => {
          this._errorHandleService.redirectToNotFound(error);
        }
      );
  }

  async getDadosUsuario() {
    let companyId = this.authService.companyID,
      restrictionKey = this.authService.restrictionKey,
      usuarioId = this.authService.userID;

    await this._dashboardService
      .dadosUsuario(companyId, restrictionKey, usuarioId)
      .subscribe(
        (response) => {
          if (response.success) {
          } else {
            this._errorHandleService.throwConsoleError(response);
          }
        },
        (error) => {
          this._errorHandleService.redirectToNotFound(error);
        }
      );
  }

  async getDadosFornecedor() {
    let companyId = this.authService.companyID,
      restrictionKey = this.authService.restrictionKey;
    await this._dashboardService
      .dadosFornecedor(companyId, restrictionKey)
      .subscribe(
        (response) => {
          if (response.success) {
          } else {
            this._errorHandleService.throwConsoleError(response);
          }
        },
        (error) => {
          this._errorHandleService.redirectToNotFound(error);
        }
      );
  }
}